export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ?? "http://localhost:8000/";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "";

export const DASHBOARD_ASSISTANT_ID =
  process.env.REACT_APP_DASHBOARD_ASSISTANT_ID ??
  "c3c7221c-8f4d-4864-a4c9-e0bacec7af18";
